import React from "react";
import Button from "@mui/material/Button";

function WeekNumber({ text }) {
  return (
    <div>
      <Button
        style={{
          fontSize: 12,
          letterSpacing: 0.3,
          minWidth: 24,
          minHeight: 24,
          textAlign: "center",
          color: "rgba(0, 0, 0, 0.54)",
        }}
        value="week"
      >
        {text}
      </Button>
    </div>
  );
}

export default WeekNumber;
